"use client";

import { FC, PropsWithChildren } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import { IPolicyPagesSportConfig } from "@finbackoffice/fe-core";
import { useSportFeedType } from "hooks/sportsbook/useSportFeedType";
import { useDevice } from "hooks";
import { NavigationBar } from "components/base/navigation/NavigationBar";
import { Carousel, CarouselSlide } from "components/base/carousel/Carousel";
import PoliciesCommonContent from "components/policies/PoliciesCommonContent";
import { PoliciesNavItem } from "./components/PoliciesNavItem";
import styles from "../policies.module.sass";
export const PoliciesSportsbookLayout: FC<
    PropsWithChildren<{ sportConfig: IPolicyPagesSportConfig[] }>
> = ({ sportConfig, children }) => {
    const { isBCFeed } = useSportFeedType();
    const { isMobileDevice } = useDevice();
    return (
        <PoliciesCommonContent
            translationKey="sportsbook"
            translationScope={TranslationScopes.PoliciesSportsbook}
            headingIcon={{ width: 20, height: 20 }}>
            <NavigationBar className={styles.sportsNav}>
                {!isMobileDevice ? (
                    <Carousel options={{ dragFree: true }}>
                        {sportConfig.map((sport, index: number) => (
                            <CarouselSlide key={index}>
                                <PoliciesNavItem
                                    key={sport.name}
                                    name={sport.name}
                                    isBCFeed={isBCFeed}
                                />
                            </CarouselSlide>
                        ))}
                    </Carousel>
                ) : (
                    <>
                        {sportConfig.map((sport) => (
                            <PoliciesNavItem
                                key={sport.name}
                                name={sport.name}
                                isBCFeed={isBCFeed}
                            />
                        ))}
                    </>
                )}
            </NavigationBar>
            {children}
        </PoliciesCommonContent>
    );
};
